export default "__VITE_ASSET__367ded52__"